import { z } from 'zod';
import { $CandidateActivitySphere } from './CandidateActivitySphere';
import { $CandidateCity } from './CandidateCity';
import { $CandidateCompany } from './CandidateCompany';
import { $CandidateCurrency } from './CandidateCurrency';
import { $CandidateDecisionType } from './CandidateDecisionType';
import { $CandidateNamedReference } from './CandidateNamedReference';
import { $CandidatePaymentPeriod } from './CandidatePaymentPeriod';
import { $CandidateTariff } from './CandidateTariff';
import { $CandidateUser } from './CandidateUser';
import { $CandidateVacancyActivity } from './CandidateVacancyActivity';

export const $CandidateVacancy = z.object({
  id: z.number(),
  name: z.string(),
  salaryFrom: z.number(),
  salaryTo: z.number(),
  mandatoryRequirements: z.string(),
  additionalRequirements: z.string(),
  responsibilities: z.string(),
  requiredCandidatesCount: z.number(),
  startDate: z.string().nullable(),
  status: z.string(),
  interviewFinalMessage: z.string().nullable(),
  ai_sphere_fill: z.boolean(),
  candidateVacancyMatchPercent: z.number(),
  candidateVacancyStatus: z.string(),
  candidateVacancyCreatedAt: z.string(),
  decisionType: $CandidateDecisionType,
  createdAt: z.string(),
  updatedAt: z.string(),
  vacancyActivities: z.array($CandidateVacancyActivity).optional(),
  currency: $CandidateCurrency.optional(),
  company: $CandidateCompany.optional(),
  cities: z.array($CandidateCity).optional(),
  city: $CandidateCity.optional(),
  responsibleUser: $CandidateUser.optional(),
  activitySpheres: z.array($CandidateActivitySphere).optional(),
  employmentTypes: z.array($CandidateNamedReference).optional(),
  scheduleWorks: z.array($CandidateNamedReference).optional(),
  skills: z.array($CandidateNamedReference).optional(),
  paymentPeriod: $CandidatePaymentPeriod.optional(),
  tariffs: z.array($CandidateTariff).optional(),
  candidates: z.array(z.unknown()).optional(),
});
